var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-chevron-right';
                    var viewUrl = 'sprite.svg#view-icon-chevron-right';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 6.5 11',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };